module.exports = __webpack_public_path__ + "media/exercise-not-validated.e3ef2eb5.mp3";